// extracted by mini-css-extract-plugin
export var heroImage = "_mj-1";
export var modal = "_mj-0";